import {observer} from "mobx-react"
import {Navbar} from "../ui"
import {ReactNode} from "react"
import "./App.scss"
import {AppLoader} from "./AppLoader";
import {appStore} from "../../store";

const App = observer(function App({
                                      children
                                  }: {
    children?: ReactNode
}) {

    return <div className={"app-wrapper"}>
        <div className={`navbar-container ${appStore.expanded ? 'expanded':''}`}>
            <Navbar expanded={appStore.expanded}/>

            <div style={{
                position: 'absolute',
                bottom: 0,
                right: 0,
                padding: '0.3em 1.0em 0.1em 1.0em',
                zIndex: '30'
            }}>
            <span
                className="material-symbols-outlined"
                style={{cursor: 'pointer'}}
                onClick={() => appStore.expanded = !appStore.expanded}
            >keyboard_double_arrow_{appStore.expanded ? 'left' : 'right'}</span>
            </div>
        </div>
        <div className={"content-container"}>
            <AppLoader />
            {children}
        </div>
    </div>
})

export {
    App
}
